import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {LargeDataAnalyticsHostname} from "../Configs/Domain";
import CryptoJS from 'crypto-js';

const hashParams = (params) => {
  const paramsString = JSON.stringify(params);
  return CryptoJS.MD5(paramsString).toString();
};



const createQueryParams = (params) => {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          queryParams.append(key, value.join(','));
        } else if (value !== null && value !== undefined){
        queryParams.append(key, value);
        }
    });
    return queryParams.toString();

}


const createApiThunk = (name, path, defaultParams) => {
  return createAsyncThunk(name, async (params, { getState, rejectWithValue }) => {
    const hash = hashParams({ ...defaultParams, ...params });
    const state = getState();

    // Check if the request has already been made
    if (state.largeDataAnalytics.requests[hash]) {
      return { name, data: state.largeDataAnalytics.requests[hash], hash };
    }

    try {
      const response = await axios.get(`${LargeDataAnalyticsHostname}${path}?${createQueryParams({ ...defaultParams, ...params })}`);
      return { name, data: response.data, hash };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  });
};



export const runProcessSimulation = createAsyncThunk(
  'scenarios/process',
  async (params, { rejectWithValue }) => {
    try {
      const { process_name, processParams, T = 1, dt = 1/252 } = params;

      // Convert processParams object to string format
      const paramsString = Object.entries(processParams)
        .map(([key, value]) => `${key}:${value}`)
        .join(',');

      const queryParams = createQueryParams({
        process_name,
        params: paramsString
      });
      console.log(`${LargeDataAnalyticsHostname}/scenarios/process?${queryParams}`);
      const response = await axios.get(`${LargeDataAnalyticsHostname}/scenarios/process?${queryParams}`);
      return { process_name, data: response.data };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


const CommonParams = {
  start_date: null,
  end_date: null,
}


const Routes = [
  {
    name: 'models/gam',
    path: '/models/gam',
    params: {
      features: [],
      targets: [],
      n_splines: 15,
      ...{...CommonParams}
    },
  },
  {
    name: 'models/regattr',
    path: '/models/attribution/regularized',
    params: {
      features: [],
      targets: [],
      ...{...CommonParams}

    }
  },
  {
    name: 'stats/correlate',
    path: '/stats/correlate',
    params: {
      symbols: [],
      method: 'pearson',
      window: 30,
      ...{...CommonParams}

    },
  },
  {
    name: 'analysis/rankFeatures',
    path: '/analysis/rank-features',
    params: {
      symbols: [],
      ...{...CommonParams}

    },
  }
];

export const largeDataAnalyticsAsyncThunks = Routes.reduce((acc, route) => {
  acc[route.name] = createApiThunk(route.name, route.path, route.params);
  return acc;
}, {});